const ReCAPTCHAHelper = {
	getToken: function (action) {
		var deferred = new $.Deferred();

		if (window.grecaptcha && window.grecaptcha.enterprise && window.reCAPTCHASiteKey) {
			// Recaptcha Cloud
			window.grecaptcha.enterprise.ready(() => {
				window.grecaptcha.enterprise.execute(window.reCAPTCHASiteKey, { action }).then(token => {
					deferred.resolve(token);
				}).catch(error => {
					deferred.reject(error);
				});
			});
		} else if (window.grecaptcha && !window.grecaptcha.enterprise) {
			// Recaptcha v2
			// Listen for v2 widget event
			document.addEventListener("mouseup", this.removeCaptchaSpinner);

			$("#recaptcha").one("Success", (event, token) => {
				document.removeEventListener("mouseup", this.removeCaptchaSpinner);
				deferred.resolve(token);
			});

			if (!window.callingReCAPTCHA) {
				grecaptcha.execute();
			}
		} else {
			deferred.resolve(null);
		}

		return deferred;
	},
	removeCaptchaSpinner(e) {
		var challenge = $("iframe[title*='recaptcha'][title*='challenge']");
		// This boolean is based on how Google is currently showing/hiding their reCaptcha challenge
		// If things start breaking, it might be because they have changed how they do this
		var isChallengeVisible = !(challenge.css("visibility") == "hidden");

		if (challenge.length > 0 && isChallengeVisible && !challenge.is(e.target) && challenge.has(e.target).length === 0) {
			$("#overlayWithSpinner").remove();
		}
	}
};

module.exports = ReCAPTCHAHelper;
